import Avatar from "components/BaseWidgets/Avatar";
import { useNavigate } from "react-router-dom";


function DetailsCard({ data, onClick, isDisabled }) {
  const navigate = useNavigate()
  
  return (
    <div
      className={`pointer details-card-wrapper ${data?.unread ? "unread" : ""} ${isDisabled && "disabled"}`}
      onClick={onClick}
    >
      <div className="flex items-start gap-4 card-container justify-between">
        <div className="flex items-start gap-4">
          <Avatar

          onClick={(e) => {
            if(data.aec_id){
              e.stopPropagation();
              navigate("/person-profile/" + data?.aec_id);}
            }}
            url={data?.avatar}
            size={40}
            icon={data?.icon}
            className="avatar-comp"
          />
          <div className="flex flex-col gap-0-5">
            <span className="font-body-lg fw-700">{data?.title}</span>
            <p className="font-body-normal leading-4 card-description">
              {data?.subtitle}
            </p>
          </div>
        </div>
        <span className="font-body-normal leading-4 card-description no-wrap">
          {data?.time}
        </span>
        {data?.unread && <span className="red-marker" />}
      </div>
    </div>
  );
}

export default DetailsCard;
